import axiosInstance from '../axiosConfigCMS';

export default {
  async getContent() {
    const response = await axiosInstance.get('/payment-page');
    return response.data;
  },
};
